import React from "react";
import Table from "react-bootstrap/Table";
import { images } from "../../../utils/customFn";
import "react-circular-progressbar/dist/styles.css";
import "./recencustomers.scss";
import { useNavigate } from "react-router-dom";

const RecentCustomers = ({ recentCustomers }) => {
  const navigate = useNavigate();
  return (
    <div className="recent-project-data-box">
      <div className="page-card-bg">
        <div className="flex-top-heading">
          <div className="heading-main">
            <h2 className="common-heading"> Recent Customers</h2>
          </div>
          <div className="btn-filter-flex">
            <div className="btn-see-more">
              <button
                className="common-button-light"
                onClick={() => navigate("/customers/client")}
              >
                See All
              </button>
            </div>
          </div>
        </div>

        <div className="table-data-main look-data-table-new">
          <Table responsive>
            <thead>
              <tr>
                <th>name</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Customer Type </th>
                <th>Status </th>
              </tr>
            </thead>
            <tbody>
              {recentCustomers &&
                recentCustomers.map((item) => (
                  <tr key={item.id}>
                    <td>
                      <div className=" image-flex-tabe">
                        <div className="user-info">
                          <p>
                            {item.name
                              ? item.name.length > 12
                                ? item.name.slice(0, 12) + "..."
                                : item.name
                              : "N/A"}
                          </p>
                        </div>
                      </div>
                    </td>

                    <td>
                      <div className=" image-flex-tabe">
                        <div className="user-info">
                          <p>{item.phone_number}</p>
                        </div>
                      </div>
                    </td>

                    <td>
                      <div className=" image-flex-tabe">
                        <div className="user-info">
                          <p>
                            {item.email
                              ? item.email.length > 12
                                ? item.email.slice(0, 12) + "..."
                                : item.email
                              : "N/A"}
                          </p>
                        </div>
                      </div>
                    </td>

                    <td>
                      <div className="user-type">
                        <span>{item.customer_type || "N/A"}</span>
                      </div>
                    </td>

                    <td>
                      <div className="user-info manageWidth">
                        <span
                          className={`${
                            item.status === "Active" ? "approved" : "rejected"
                          }`}
                        >
                          {item.status}
                        </span>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default RecentCustomers;
